import web from "../web";

class ProgrammesevaluationsService {
    index(token){
        return web.get("/api/programmesevaluations", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/programmesevaluations", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/programmesevaluations/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/programmesevaluations/update", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/programmesevaluations/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new ProgrammesevaluationsService()